"use client"
import AccessControlPill from "@/components/Atoms/Pills/AccessControlPill";
import TagPill_1 from "@/components/Atoms/Tags/TagPill_1";
import { dateFormat_3 } from "@/utils/frontend/dateOps";
import getTagDevIconName from "@/utils/frontend/getTagDevIconName";
import { humanizeString } from "@/utils/frontend/stringOps";
import Link from "next/link";


const FeaturedEntityCard = ({entityType, data, callback, onClick, selectedId, roundedTopBottomCorners, href, lang }) => {

// console.log("Data@FeaturedEntityCard", data)
  return (
    <div className="cursor-pointer" 
//     onClick={()=>{callback('test')}} 
    >
      <div className="w-full bg-inherit justify-center dark:border-gray-800 mb-2 ">
        <div className={`min-h-40 max-h-40 rounded-2xl ${Number(selectedId) === Number(data.id) ? 'bg-gray-200 dark:bg-gray-950 dark:border-gray-600' : 'bg-white'} ${roundedTopBottomCorners === 'topRounded' ? '' : roundedTopBottomCorners === 'bottomRounded' ? '' : false } transition duration-300 py-3 dark:bg-gray-900 hover:bg-gray-200 dark:hover:bg-gray-950`}>
          <div className="p-2">
            <div className="flex justify-between items-center">

              <h3 className="font-bold text-left text-sm text-black dark:text-white leading-8 mx-5 whitespace-nowrap overflow-hidden">
               {entityType === 'JOB' ? data.job_title[lang] : data.talent_pseudonym}
              </h3>

              <p className={`text-sm text-black dark:text-white dark:text-gray-300 mx-5 whitespace-nowrap overflow-hidden `}>
              {
              entityType==='JOB' ? `${lang === 'fr' ? 'Emploi' : ''} ${humanizeString(data.job_type)} ${lang !== 'fr' ? 'Job' : ''}` 
               : 
               data.talent_job_title?.[lang]} 
              </p>
            </div>




            {/* <div className="flex justify-between items-center">
            <div className="ml-5 dark:text-white text-sm">
            {entityType === 'JOB' ? data.job_location : data.talent_location}
            </div>
            <div className="text-sm text-black dark:text-white dark:text-gray-300 mx-5 whitespace-nowrap overflow-hidden ">
              test
            </div>
            </div> */}


            {entityType === 'JOB' ?

            <div className="ml-5 dark:text-white text-sm">
            {data.job_location}
            </div>
        :

        <div className="flex justify-between items-center">
            <div className="ml-5 dark:text-white text-sm">
            {data.talent_location}
            </div>
            <div className="text-sm text-black dark:text-white dark:text-gray-300 mx-4 whitespace-nowrap overflow-hidden ">
            {/* <AccessControlPill data={data} lang={lang}/> */}
            </div>
            </div>

            }


            

            <div className="text-left mt-2 ml-5">
            {data.tags.map(tag=> {return <span key={tag.id}>
              <TagPill_1 bgColors={'bg-gray-300 dark:bg-slate-700'} tagType='PRIMARY' iconName={getTagDevIconName(tag.tag_name)} caption={tag.tag_name}/></span>})
            }
            </div>
            {/* <div className="text-center mt-2">
            {data.tags.map(tag=> {return tag.tag_type === 'SECONDARY' && <span key={tag.id}><TagPill_1 tagType='SECONDARY' iconName={getTagDevIconName(tag.tag_name)} caption={tag.tag_name}/></span>})}
            </div> */}

            {/* <p className="text-gray-700 dark:text-gray-300 mx-5 text-left text-sm">
                {data.associated_company_name ? data.associated_company_name : data.associated_person_first_name ? data.associated_person_first_name + ' ' + data.associated_person_last_name : data.associated_job_title }
            </p> */}

            {/* <div className="text-right my-3">
              <button
                onClick={handleChangeStatus}
                className="text-xs text-white bg-indigo-500 hover:bg-indigo-600 py-1 px-2 rounded-md"
              >
                Change Status
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedEntityCard;
